import { useCurrency, useTimeWindow, useTheme } from '../lib/contexts';
import type { Currency, TimeWindow, Theme } from '../../shared/types';
import { Icons } from './Icon';
import { SettingsMenu } from './SettingsMenu';
import './../styles/components/topbar.css';

const CCYS: Currency[] = ['USD', 'EUR'];
const WINDOWS: TimeWindow[] = ['1D', '7D', '30D', '90D', '1Y', '2Y'];
const THEME_CYCLE: Record<Theme, Theme> = { dark: 'light', light: 'system', system: 'dark' };
const THEME_LABEL: Record<Theme, string> = { dark: 'Dark', light: 'Light', system: 'System' };

function fmtUpdated(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const date = d.toISOString().slice(0, 10).replace(/-/g, ' · ');
  const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${date} · ${time}`;
}

export function TopBar({ pricesUpdatedAt }: { pricesUpdatedAt?: string | null }) {
  const { ccy, setCcy } = useCurrency();
  const { win, setWin } = useTimeWindow();
  const { theme, setTheme } = useTheme();

  return (
    <div class="topbar">
      <div class="topbar-status mono">
        {pricesUpdatedAt ? (
          <span title={new Date(pricesUpdatedAt).toLocaleString()}>
            UPDATED · {fmtUpdated(pricesUpdatedAt)}
          </span>
        ) : (
          <span aria-hidden="true">&nbsp;</span>
        )}
      </div>
      <div class="topbar-controls">
        <div class="seg" role="group" aria-label="Currency">
          {CCYS.map((c) => (
            <button
              key={c}
              class={`seg-btn ${ccy === c ? 'is-active' : ''}`}
              onClick={() => setCcy(c)}
            >
              {c}
            </button>
          ))}
        </div>
        <div class="seg" role="group" aria-label="Time window">
          {WINDOWS.map((w) => (
            <button
              key={w}
              class={`seg-btn ${win === w ? 'is-active' : ''}`}
              onClick={() => setWin(w)}
            >
              {w}
            </button>
          ))}
        </div>
        <button
          class="seg-btn icon-btn"
          aria-label={`Theme: ${THEME_LABEL[theme]}`}
          title={`Theme: ${THEME_LABEL[theme]}`}
          onClick={() => setTheme(THEME_CYCLE[theme])}
        >
          {theme === 'dark' ? (
            <Icons.Moon size={14} />
          ) : theme === 'light' ? (
            <Icons.Sun size={14} />
          ) : (
            <Icons.Monitor size={14} />
          )}
        </button>
        <SettingsMenu />
      </div>
    </div>
  );
}
